import { shallowEqual, useSelector } from 'react-redux';
import makeSelectFn from '../selectors/userSelector';

export const useUser = () => {
    const userData = useSelector(makeSelectFn(), shallowEqual);
    
    return userData;
}